import Swiper, { Navigation, Pagination, Autoplay, SwiperOptions, Scrollbar } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import { fetchText } from '../fetch-helper/fetch-helper';
import carouselConfig, { getCarouselConfig } from './carousel-config';

import '../../../css/bem/_component-carousel.scss';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay, Scrollbar]);

export default function (context:Document|HTMLElement = document) {
    console.log('Component Carousel Module Loaded');
    (context.querySelectorAll('.swiper-container:not(.swiper-prevent)') as NodeListOf<HTMLElement>).forEach((carousel) => {
        const config: SwiperOptions = getCarouselConfig(carousel, carousel.dataset.config);

        const isAjax = carousel.dataset.url;
        const hasInit = carousel.dataset.hasInitialized;
        if (hasInit == 'true') return;

        if (isAjax) {
            const prevButton = carousel.querySelector('.swiper-button-prev');
            const nextButton = carousel.querySelector('.swiper-button-next');
            if (prevButton)
                prevButton.addEventListener('click', (e) => {
                    e.preventDefault();
                });
            if (nextButton)
                nextButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    ajaxCarouselSlide(carousel);
                    prevButton.classList.remove('swiper-button-disabled');
                });
        } else {
            const mySwiper = new Swiper(carousel, {
                ...config,
                Init: (swiper) => {
                    /*  Wouldnt have to do this if we have updated to latest version... */
                    if (swiper.slides.length === 1) disablePagination(carousel);
                }
            } as SwiperOptions);
            carousel.dataset.hasInitialized = 'true';
        }
    });
}

const disablePagination = (carousel) => {
    const pagination = carousel.querySelector('.swiper-pagination');
    if (!pagination) return;
    pagination.classList.add('d-none');
};

const ajaxCarouselSlide = (carousel) => {
    if (!_hasLoadedExtraImages(carousel)) {
        _loadExtraImages(carousel);
        return;
    }
};

const _hasLoadedExtraImages = (carousel) => {
    return carousel.dataset.hasLoaded;
};

const _loadExtraImages = (carousel) => {
    const url = carousel.dataset.url;
    const config = carouselConfig[carousel.dataset.config];
    const carouselImageContainer = carousel.querySelector('.swiper-wrapper');
    const currentImage: HTMLImageElement = carouselImageContainer.querySelector('.swiper-slide img');

    carousel.style.height = `${carousel.clientHeight}px`;

    Promise.all([_duplicateOriginalImage(currentImage, carousel), fetchText(url, null)])
        .then(([clonedImage, ajaxResponse]) => {
            const images = ajaxResponse;
            carouselImageContainer.innerHTML = images;

            return clonedImage;
        })
        .then(rafAsync)
        .then(rafAsync)
        .then(rafAsync)
        .then((clonedImage: HTMLElement) => {
            carousel.dataset.hasLoaded = true;
            const mySwiper = new Swiper(carousel, config);
            clonedImage?.parentNode?.removeChild(clonedImage);
            carousel.dataset.hasInitialized = 'true';
            mySwiper.slideNext();
        });
};

const _duplicateOriginalImage = (image, carousel) => {
    return new Promise((resolve) => {
        const clonedImage = document.createElement('img');
        const src: string = image.getAttribute('src');

        clonedImage.setAttribute('src', src);
        clonedImage.classList.add('component-carousel__temp-ajax-image', 'img-fluid');

        carousel.appendChild(clonedImage);

        clonedImage.addEventListener('load', () => {
            resolve(clonedImage);
        });
    }) as Promise<HTMLImageElement>;
};

const rafAsync = (data) => {
    return new Promise((resolve) => {
        requestAnimationFrame(() => resolve(data));
    });
};
